import PublicationsSlider3Items from './PublicationsSlider3Items'

export default PublicationsSlider3Items
